import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import DownloadIcon from '@mui/icons-material/Download';
import {
  Container,
  Typography,
  Card,
  Divider,
  Box,
  CardMedia,
  Button,
  styled,
  createTheme,
  ThemeProvider
} from '@mui/material';
import moment from 'moment';


const statistiquesHydrauliqueData = [
  {
    
    annuaires: "Annuaire statistique des secteurs « Énergie, eau potable & assainissement de base » et « Mines », édition 2023",
    description: "En 2023, Bujumbura reste le premier consommateur d'électricité (239,6 millions de kWh), tandis que Nyanza-Lac (916 782 kWh) est le dernier, avec une croissance notable dans la Région Ouest et des disparités régionales marquées.",
    date: "2024-12-31",
    image: 'documents/sectoriels/annuaire2021.png',
    link: "/documents/Sectorials/Annuaire-Statistique-du-Ministère-de-hydraulique-de-energie-et-des-mines-edition-2023-Version-revisé.pdf"
  }
];

function MiniHdraulique() {
  const [visibleCount, setVisibleCount] = useState(2); 
  const theme = createTheme({
    palette: {
      primary: {
        main: '#388E3C'
      },
      background: {
        default: '#f5f5f5'
      }
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      body1: {
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#6B778C'
      },
      h4: {
        fontWeight: '600'
      }
    }
  });

  const StyledCard = styled(Card)(({ theme }) => ({
    borderRadius: '12px',
    overflow: 'hidden',
    marginBottom: '20px'
  }));

  const handleShowMore = () => {
    setVisibleCount((prevCount) => Math.min(prevCount + 2, statistiquesHydrauliqueData.length));
  };

  return (
    <ThemeProvider theme={theme}>
      <div style={{ backgroundColor: theme.palette.background.default, paddingBottom: '32px' }}>
        <NavigationBar />
 
        <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          <Typography variant="h4" align="justify" gutterBottom style={{ color: theme.palette.primary.main, marginBottom: '16px' }}>
               Ministère de l’Hydraulique, de l’Energie et des Mines
          </Typography>
          <Divider style={{ margin: '16px 0' }} />
          <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '24px' }}>
                 Ce portail donne accès aux données statistiques officielles du ministère chargé de la gestion des ressources hydrauliques, 
                 des politiques énergétiques et de l'exploitation minière. Vous y trouverez des rapports annuels, des indicateurs clés 
                et des analyses sectorielles actualisées pour suivre l'évolution de ces secteurs stratégiques au Burundi.
           </Typography>
            {/* Affichage des rapports */}
            {statistiquesHydrauliqueData.slice(0, visibleCount).map((statistique, index) => (
                      <StyledCard key={index} elevation={1}>
                        <Box sx={{ display: 'flex' }}>
                          <a 
                            href={statistique.link} 
                            style={{ textDecoration: 'none', color: 'inherit' }} 
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <CardMedia
                              component="img"
                              sx={{ width: 71, height: 100, m: 2 }}
                              image={statistique.image} 
                              alt={statistique.annuaires}
                            />
                          </a>
                          <Box sx={{ display: 'flex', flexDirection: 'column', pl: 2, pt: 2 }}>
                            <Typography variant="h6" component="div" style={{ fontWeight: 'bold', marginBottom: '10px', color: theme.palette.primary.main }}>
                              <a 
                                href={statistique.link} 
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ textDecoration: 'none', color: 'inherit' }}
                              >
                                {<DownloadIcon />}{statistique.annuaires}
                              </a>
                            </Typography>
                            <Typography variant="body2" component="div" style={{ color: '#555', marginBottom: '10px' }}>
                              {statistique.description}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                              Publié en {moment(statistique.date).format('MMMM YYYY')}
                            </Typography>
                          </Box>
                        </Box>
                      </StyledCard>
                    ))}
   

         
          {visibleCount < statistiquesHydrauliqueData.length && (
            <Button 
              onClick={handleShowMore} 
              style={{
                marginTop: '20px',
                backgroundColor: theme.palette.primary.main,
                color: 'white'
              }}
            >
              Plus de Statistiques
            </Button>
          )}
        </Container>
        <br />
        <br />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default MiniHdraulique;